<div class="display-flex flex-column">
  <ucx-message-bubble
    [messageCopy]="getCardHtml()"
    [isTypeUser]="isUserMessage"
    [links]="clickableLinks"
    [isMessageTypeSame]="isMessageTypeSame"
    [onClickLink]="onClickableLink"
    [currentTimestamp]="timeStamp"
  ></ucx-message-bubble>
</div>
<div
  *ngIf="cannedResponses?.length && isCannedResponseVisible"
  class="buttons-div"
  [ngClass]="{
    'flex-row': isFeedbackMessage,
    'flex-column': !isFeedbackMessage
  }"
>
  <ng-container *ngIf="cannedResponses?.length">
    <button
      *ngFor="let response of cannedResponses"
      ucxJsHighlight
      ucx-button
      class="response-btn"
      [ngClass]="{ 'small-btn': isFeedbackMessage }"
      [size]="isFeedbackMessage ? 'small' : ''"
      (click)="cannedResponseClick(response)"
    >
      {{ response.value }}
    </button>
  </ng-container>
</div>
